<template>
  <!-- 推荐人列表 -->
  <div style="min-width: 1200px" class="big">
    <div class="page_title flex_between">
      <span>推荐人编辑</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="filterBox flex wrap">
          <div class="box">邀请码</div>
          <div class="box">{{ recommender_code }}</div>
          <div class="box red">{{ info.phone ? "已维护" : "未维护" }}</div>
          <div style="margin-right: 20px">
            <el-button
              type="primary"
              size="small"
              @click="Unbind"
              v-if="info.openid"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('404') : false
              "
              >解除微信绑定</el-button
            >
          </div>
          <div>
            <span style="margin-right: 10px">助手端是否可联系患者</span>
            <span>
              <el-radio-group
                v-model="info.contact_patient"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1134') : false
                "
                @change="setRecommender"
              >
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </span>
          </div>
        </div>
        <!-- 筛选项 -->
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">推荐人姓名</div>
            <el-input
              v-model="recommender_name"
              size="small"
              style="width: 150px"
              :maxlength="8"
            />
          </div>
          <div class="box flex">
            <div class="label">推荐人手机号</div>
            <el-input
              v-model="phone"
              size="small"
              style="width: 150px"
              :maxlength="11"
            />
          </div>
          <div class="box flex">
            <el-button
              type="primary"
              size="small"
              @click="saveRecommender"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('143') : disabled
              "
              >保存</el-button
            >
            <el-button
              size="small"
              @click="deleteRecommender"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('144') : false
              "
              >删除</el-button
            >
          </div>

          <div class="box" style="margin-left: auto">
            <el-button
              type="primary"
              size="small"
              @click="docRemarkBtn"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1525') : false
              "
              >批量备注</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="
                () => {
                  this.getDoctorList();
                  addDocShow = true;
                }
              "
              :disabled="
                module_id_array[0] ? !module_id_array.includes('146') : false
              "
              >新增医生</el-button
            >
          </div>
        </div>
        <!-- 搜索栏 -->
        <div class="search_box">
          <div class="item">
            <span>医生姓名</span>
            <el-input
              v-model="searchForm.doctor_name"
              size="medium"
              clearable
              placeholder="医生姓名"
              class="input_width"
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机号</span>
            <el-input
              v-model="searchForm.phone"
              size="medium"
              clearable
              placeholder="医生手机号"
              class="input_width"
            ></el-input>
          </div>
          <div class="item">
            <span>医院名称</span>
            <el-input
              v-model="searchForm.hospital"
              size="medium"
              clearable
              placeholder="医院名称"
              class="input_width"
            ></el-input>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            @selection-change="handleSelectionListChange"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="doctor_name" label="医生姓名" width="150" />
            <el-table-column label="性别">
              <template slot-scope="scope">{{
                scope.row.sex == 1 ? "男" : "女"
              }}</template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" />
            <el-table-column prop="title" label="职称" />
            <el-table-column prop="department_name" label="科室" />
            <el-table-column prop="hospital" label="医院名称" />
            <el-table-column prop="doc_remark" label="客服备注" />
            <el-table-column prop="recommender_time" label="绑定时间">
              <template slot-scope="scope">{{
                scope.row.recommender_time | dateFormat
              }}</template>
            </el-table-column>
            <el-table-column prop="more" label="其他分摊人">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.more"
                  style="cursor: pointer"
                  type="primary"
                  @click="lookDetails(scope.row)"
                >
                  {{ scope.row.more.recommender_name }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="unbindDoctor(scope.row.doctor_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('145')
                      : false
                  "
                  >解绑</el-button
                >
                <el-button
                  type="text"
                  @click="setMoreBtn(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1928')
                      : false
                  "
                  >设置分摊比例</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 批量备注弹框 -->
    <el-dialog
      title="客服备注"
      :visible.sync="docRemarkShow"
      width="800px"
      style="text-align: left"
      :close-on-click-modal="false"
      center
    >
      <div class="content" style="padding: 20px">
        <el-input
          v-model="doc_remark"
          type="textarea"
          :rows="7"
          maxlength="300"
          show-word-limit
          placeholder="请输入内容"
        >
        </el-input>
        <div>注：若医生已有客服备注，将被自动追加到已有备注后</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="docRemarkShow = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirmRemark" size="medium"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增医生弹窗 -->
    <el-dialog
      title="新增医生"
      :visible.sync="addDocShow"
      width="1100px"
      style="text-align: left"
      :close-on-click-modal="false"
      center
    >
      <div class="content" style="padding: 20px">
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">医生姓名</div>
            <el-input
              v-model="doctor_name"
              size="small"
              style="width: 150px"
              :maxlength="8"
            />
          </div>
          <div class="box flex">
            <div class="label">医院名称</div>
            <el-input
              v-model="hospital"
              size="small"
              style="width: 150px"
              :maxlength="8"
            />
          </div>
          <div class="box flex">
            <div class="label">手机号</div>
            <el-input
              v-model="doctor_phone"
              size="small"
              style="width: 150px"
              :maxlength="11"
            />
          </div>
          <div class="box flex">
            <div class="label">推荐人姓名</div>
            <el-input
              v-model="recommender_namedia"
              size="small"
              style="width: 150px"
              :maxlength="8"
            />
          </div>
          <el-button
            type="info"
            class="search-button"
            @click="getDoctorList"
            size="small"
            >查询</el-button
          >
        </div>
        <p class="red">选择已绑定的医生，将解除医生与原推荐人的绑定关系</p>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="doctorList"
            tooltip-effect="dark"
            style="width: 100%"
            height="300px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="doctor_name" label="医生姓名" />
            <el-table-column prop="phone" label="手机号" />
            <el-table-column prop="hospital" label="医院名称" />
            <el-table-column prop="recommender_name" label="推荐人姓名" />
            <el-table-column label="是否绑定">
              <template slot-scope="scope">{{
                scope.row.recommender_code ? "已绑定" : "未绑定"
              }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addDoctor(1)" size="medium"
          >确 定</el-button
        >
        <el-button type="primary" @click="addDoctor(2)" size="medium"
          >确定并继续添加</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置分销比例 -->
    <el-dialog
      title="设置分销比例 "
      :visible.sync="setMoreDia"
      width="800px"
      custom-class="referrer-proportion"
    >
      <div style="padding: 10px">
        <el-form :model="setMoreForm" ref="ruleForm" label-width="120px">
          <el-form-item label="其他分摊人比例" prop="proportion">
            <el-input-number
              v-model="setMoreForm.proportion"
              size="small"
              :min="1"
              :max="99"
              :precision="0"
              :controls="false"
            ></el-input-number
            >&nbsp;%
          </el-form-item>

          <el-form-item label="其他分摊人" prop="recommender_code">
            <el-input
              v-model="keywords"
              clearable
              size="small"
              style="width: 200px"
              @blur="getStaffBaseList"
              placeholder="请输入查询"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getStaffBaseList"
              ></el-button
            ></el-input>
            <div style="width: 200px; opacity: 0"></div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px"
              @click="saveSetMore('ruleForm')"
              >保 存</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          :data="staffBaseList"
          tooltip-effect="dark"
          height="500"
          style="width: 100%"
          v-loading="staffLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column prop="recommender_name" label="推荐人姓名" />
          <el-table-column prop="recommender_code" label="邀请码" />
          <el-table-column prop="phone" label="手机号" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="confirmStaff(scope.row)"
                >选择该推荐人</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="staffTotalNum > 0"
          :total="staffTotalNum"
          :page.sync="staffPagination.page"
          :limit.sync="staffPagination.pageNumber"
          @pagination="getStaffBaseList"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import staff from "@/api/staff.js";
import Pagination from "@/components/Pagination";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      recommender_code: this.$route.query.recommender_code,
      recommender_name: "",
      phone: "",
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      searchForm: {
        doctor_name: "",
        phone: "",
        hospital: "",
      },
      tableData: [],
      info: {},
      addDocShow: false,
      doctor_name: "",
      hospital: "",
      doctor_phone: "",
      recommender_namedia: "",
      doctorList: [],
      multipleSelection: [], //选择的医生列表
      docRemarkShow: false,
      multipleListSelection: [],
      doc_remark: "",
      setMoreDia: false,
      setMoreForm: {
        doctor_id: "",
        proportion: undefined,
        recommender_code: "",
      },
      keywords: "",
      staffLoading: false,
      staffTotalNum: 0,
      staffPagination: {
        page: 1,
        pageNumber: 10,
      },
      staffBaseList: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:ss");
    },
  },
  computed: {
    disabled() {
      if (
        !this.phone ||
        !this.recommender_name ||
        (this.phone == this.info.phone &&
          this.recommender_name == this.info.recommender_name)
      ) {
        return true;
      } else {
        return false;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getInfo();
    this.getList();
  },
  methods: {
    getInfo() {
      let data = {
        recommender_code: this.recommender_code,
      };
      this.axios
        .post("platform/activity/getRecommenderInfo", data)
        .then((res) => {
          this.info = res.data.info;
          this.recommender_name = this.info.recommender_name;
          this.phone = this.info.phone;
        });
    },
    //获取已绑定医生列表
    getList() {
      let data = {
        recommender_code: this.recommender_code,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      data = Object.assign(data, this.searchForm);
      this.axios
        .post("platform/activity/getRecommenderDoctorList", data)
        .then((res) => {
          let list = res.data.list;
          this.totalNum = res.data.total;
          this.tableData = list;
        });
    },
    //获取医生列表
    getDoctorList() {
      let data = {
        doctor_name: this.doctor_name,
        hospital: this.doctor_hospital,
        phone: this.doctor_phone,
        hospital: this.hospital,
        recommender_name: this.recommender_namedia,
        page: 1,
        pageNumber: 1000,
      };
      this.axios.post("platform/activity/searchDoctor", data).then((res) => {
        this.doctorList = res.data.list;
      });
    },
    //保存联系人
    saveRecommender() {
      this.$confirm("推荐人信息已修改，是否保存？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            recommender_code: this.recommender_code,
            recommender_name: this.recommender_name,
            phone: this.phone,
          };
          return this.axios.post("platform/activity/saveRecommender", data);
        })
        .then((res) => {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.getInfo();
        })
        .catch(() => {
          this.recommender_name = this.info.recommender_name;
          this.phone = this.info.phone;
        });
    },
    // 删除联系人
    deleteRecommender() {
      this.$confirm(
        "删除该推荐人后，已绑定医生将失去推荐人，确定删除？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          let data = {
            recommender_code: this.recommender_code,
          };
          return this.axios.post("platform/activity/deleteRecommender", data);
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getInfo();
          this.getList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //解绑
    unbindDoctor(doctor_id) {
      this.$confirm("解绑后，医生将失去推荐人，是否解绑？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id,
          };
          return this.axios.post("platform/activity/unbindDoctor", data);
        })
        .then((res) => {
          this.$message({
            message: "解绑成功",
            type: "success",
          });
          this.getList();
        })
        .catch(() => {});
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    back() {
      history.back();
    },
    //选择绑定医生
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //绑定医生 type:1添加关闭弹框 2添加并继续
    addDoctor(type) {
      if (this.multipleSelection.length == 0) return;
      let doctor_id = this.multipleSelection.map((ele) => {
        return ele.doctor_id;
      });
      doctor_id = doctor_id.toString();
      let data = {
        recommender_code: this.recommender_code,
        doctor_id,
      };
      this.axios.post("platform/activity/addDoctor", data).then((res) => {
        this.$message({
          message: "绑定成功",
          type: "success",
        });
        this.doctor_name = "";
        this.hospital = "";
        this.doctor_phone = "";
        this.recommender_namedia = "";
        this.getList();
        type == 1 ? (this.addDocShow = false) : "";
        this.getDoctorList();
      });
    },
    //解除微信绑定
    Unbind() {
      let recommender_code = this.$route.query.recommender_code;
      this.axios
        .post("platform/activity/unbindWechat", { recommender_code })
        .then((res) => {
          this.$message({
            message: "成功解除微信绑定",
            type: "success",
          });
          this.getInfo();
        });
    },
    //设置是否可联系患者
    setRecommender(value) {
      let data = {
        recommender_code: this.$route.query.recommender_code,
        contact_patient: value,
      };
      this.axios.post("platform/activity/setRecommender", data).then((res) => {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getInfo();
      });
    },
    // 批量备注
    handleSelectionListChange(val) {
      this.multipleListSelection = val.map((item) => item.doctor_id);
    },
    docRemarkBtn() {
      if (!this.multipleListSelection.length) {
        this.$message.warning("请选择需要备注的医生");
        return;
      }
      this.docRemarkShow = true;
      this.doc_remark = "";
    },
    confirmRemark() {
      if (this.doc_remark == "") {
        this.$message.error("请输入内容");
        return;
      }
      let params = {
        doc_remark: this.doc_remark,
        doctor_id: this.multipleListSelection,
      };
      this.axios
        .post("platform/activity/setBatchDocRemark", params)
        .then((res) => {
          this.$message({
            message: "备注成功",
            type: "success",
          });
          this.docRemarkShow = false;
          this.getList();
        });
    },
    // 设置分摊比例
    setMoreBtn(row) {
      let { doctor_id, proportion, recommender_code, recommender_name } = row;
      this.setMoreForm = {
        doctor_id,
        proportion: undefined,
        recommender_code: "",
      };
      this.keywords = "";
      this.staffBaseList = [];
      this.setMoreDia = true;
    },
    // 查看详情
    lookDetails(row) {
      let info = row.more;
      let htmlStr = `<div style="display: flex;flex-direction: column;align-items: flex-start;"> 
                      <div style="margin-bottom:10px">绑定业务比例：${
                        info.up_proportion
                      }%</div> 
                      <div style="margin-bottom:10px">其他分摊人姓名：${
                        info.recommender_name
                      }</div> 
                      <div style="margin-bottom:10px">其他分摊人工号：${
                        info.recommender_code
                      }</div> 
                      <div style="margin-bottom:10px">其他分摊人分摊比例：${
                        info.proportion
                      }%</div> 
                      <div style="margin-bottom:10px">设置时间：${dayjs
                        .unix(info.update_time)
                        .format("YYYY-MM-DD HH:ss")}</div> 
                      <div style="margin-bottom:10px">设置人：${
                        info.set_name
                      }</div>
                    </div>`;
      this.$alert(htmlStr, "详情", {
        dangerouslyUseHTMLString: true,
      });
    },
    // 员工基础列表
    getStaffBaseList() {
      this.setMoreDia = true;
      this.staffLoading = true;
      let params = Object.assign(
        { keywords: this.keywords },
        this.staffPagination
      );
      staff
        .getStaffBaseList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.staffBaseList = data.list;
            this.staffTotalNum = data.total;
            this.keywords = "";
          }
          this.staffLoading = false;
        })
        .catch((err) => (this.staffLoading = false));
    },
    saveSetMore() {
      let { proportion, recommender_code } = this.setMoreForm;
      if (!proportion) {
        this.$message.warning("请输入比例");
        return;
      }
      if (!recommender_code || recommender_code == "") {
        this.$message.warning("请选择分摊人");
        return;
      }
      let params = Object.assign({}, this.setMoreForm);
      this.axios
        .post("platform/activity/setMoreRecommender", params)
        .then((res) => {
          this.$message.success("设置成功");
          this.setMoreDia = false;
          this.getInfo();
          this.getList();
        });
    },
    confirmStaff(row) {
      this.setMoreForm.recommender_code = row.recommender_code;
      this.keywords = row.recommender_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.search_box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 80px;
      margin-right: 10px;
      text-align: right;
      white-space: nowrap;
    }
  }
  .input_width {
    width: 160px;
  }
}
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
</style>
<style lang="scss">
.referrer-proportion {
  .el-form {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
}
</style>
